import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import CardContent from "@mui/material/CardContent";
import FormControlLabel from "@mui/material/FormControlLabel";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
// import AdapterDateFns from '@mui/lab/AdapterDateFns';
// import LocalizationProvider from '@mui/lab/LocalizationProvider';
// import DesktopDatePicker from '@mui/lab/DesktopDatePicker';

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";

import Input from "@mui/material/Input";
import session from "../../api/session";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
// import Link from "@mui/material/Link";
import Autocomplete from "@mui/material/Autocomplete";
import grLocale from "date-fns/locale/el";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import EventSpy from "components/eventSpy";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  // width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  width: "60%",
};

const cardBox = {
  display: 'flex',
  flexDirection: 'row',
  gap: '16px',
  border: '1px solid',
  padding: '8px',
  borderRadius: '3px',
  color: '#c4c4c4'
}

const cardBoxTypo = {
  color: "#666666",
  top: "-19px",
  position: 'relative',
  background: 'white',
  fontSize: '13px'
}

function ParabaseisModal(props) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [value, setValue] = React.useState(
    props.date ? new Date(props.date) : null
  );
  const [eidos, setEidosParabasi] = React.useState(
    props.selectedEidos ? props.selectedEidos : ""
  );
  const [stadio, setStadioParabasi] = React.useState(
    props.selectedStadio ? props.selectedStadio : ""
  );
  // const [stadioUpdate, setStadioUpdate] = React.useState(props.updateStadia)
  const [textValue, setTextValue] = React.useState(
    props.comments ? props.comments : ""
  );
  const [selectedFile, setSelectedFile] = React.useState(null);
  const [checked, setChecked] = React.useState(
    props.checkAnaklisi ? true : false
  );
  const [checkedFile, setCheckedFile] = React.useState(false);
  const [penalty, setPenalty] = React.useState(
    props.selectedPenalty ? props.selectedPenalty : ""
  );

  const handlePenalty = (e) => {
    console.log(e.target.value);

    setPenalty(e.target.value);
  };

  const handleSelectChange = (event) => {
    setStadioParabasi(event.target.value);
  };
  const handleEidosSelectChange = (event) => {
    setEidosParabasi(event.target.value);
  };

  const dateChange = (newValue) => {
    setValue(newValue);
  };

  const handleChangeCheck = (event) => {
    setChecked(event.target.checked);
  };
  const handleFileChecked = (event) => {
    setCheckedFile(event.target.checked);
  };

  const handleChangeText = (event) => {
    setTextValue(event.target.value);
  };

  const SaveCard = () => {
    if (value == null || value === "") {
      alert("Παρακαλώ συμπληρώστε την Ημερομηνία");
      return;
    }

    let data = new FormData();
    if (selectedFile) {
      data.append("file", selectedFile);
    }

    // data.append('date', value.toLocaleDateString().split('/').reverse().join('-'))
    data.append(
      "date",
      value
        .toLocaleDateString("el", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .split("/")
        .reverse()
        .join("-")
    );
    data.append("stadio", stadio);
    data.append("eidos", eidos);
    data.append("anaklisi_adeias", checked);
    // data.append('comments', textValue)
    data.append("penalty", penalty);
    data.append("business", props.personID);
    data.append("created_by", props.created_by);

    if (props.action === "Create") {
      session
        .post(`api/business-parabaseis/create/`, data, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((resp) => {
          EventSpy(1, `Δημιουργία Παράβασης ${JSON.stringify(resp.data)}`);
          setOpen(false);
          props.handleChange();
          props.handleSpinner("parabasiSpinner");
        });
    }
    if (props.action === "Update") {
      if (checkedFile === true) {
        data.delete("file");
        data.append("file", "");
      }

      session
        .put(`api/business-parabaseis/${props.id}/update/`, data, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((resp) => {
          EventSpy(2, `Ενημέρωση Παράβασης ${JSON.stringify(resp.data)}`);
          setOpen(false);
          props.handleChange();
          props.handleSpinner("parabasiSpinner");
        });
      setCheckedFile(false);
    }
  };


  return (
    <div>
      <Button onClick={handleOpen} variant="outlined">
        {" "}
        {props.buttonTitle ? props.buttonTitle : "Δημιουργια"}
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {props.title ? props.title : "Δημιουργία"} Παράβασης
          </Typography>
          <hr />
          <Stack spacing={5}>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <CardContent>
                    <LocalizationProvider
                      dateAdapter={AdapterDateFns}
                      adapterLocale={grLocale}
                    >
                      <Stack spacing={4}>
                        <DesktopDatePicker
                          label="Ημερομηνία"
                          // inputFormat="yyy/MM/dd"
                          inputFormat="dd/MM/yyyy"
                          value={value}
                          // onChange={(newValue) => setValue(newValue)}
                          onChange={(newValue) => dateChange(newValue)}
                          renderInput={(params) => <TextField {...params} />}
                        />
                      </Stack>
                    </LocalizationProvider>
                  </CardContent>
                </Grid>
                <Grid item md={12}>
                  <CardContent>
                    <FormControl
                      variant="standard"
                      sx={{ m: 1, minWidth: 250 }}
                    >
                      <InputLabel id="demo-simple-select-standard-label">
                        Σταδιο Παράβασης
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        value={stadio}
                        onChange={handleSelectChange}
                        label="Σταδιο Παράβασης"
                      >
                        <MenuItem value="">
                          <em>None</em>
                        </MenuItem>

                        {props.stadia &&
                          props.stadia.length > 0 &&
                          props.stadia.map((e) => (
                            <MenuItem key={e.id} value={e.id}>
                              {e.title}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </CardContent>
                </Grid>
                <Grid item xs={12}>
                  <CardContent>
                    <FormControl
                      variant="standard"
                      sx={{ m: 1, minWidth: 250 }}
                    >
                      <InputLabel id="demo-simple-select-standard-label">
                        Είδος Παράβασης
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        value={eidos}
                        onChange={handleEidosSelectChange}
                        label="Είδος Παράβασης"
                      >
                        <MenuItem value="">
                          <em>None</em>
                        </MenuItem>
                        {props.eidos &&
                          props.eidos.length > 0 &&
                          props.eidos.map((e) => (
                            <MenuItem key={e.id} value={e.id}>
                              {e.title}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </CardContent>
                </Grid>
                <Grid item xs={12}>
                  <CardContent>
                    <FormControl
                      variant="standard"
                      sx={{ m: 1, minWidth: 250 }}
                    >
                      <InputLabel id="demo-simple-select-standard-label">
                        Ποινή
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-standard-label1"
                        id="demo-simple-select-standard1"
                        value={penalty}
                        onChange={handlePenalty}
                        label="Ποινή"
                      >
                        <MenuItem value="">
                          <em>None</em>
                        </MenuItem>
                        {props.penalties &&
                          props.penalties.length > 0 &&
                          props.penalties.map((e) => (
                            <MenuItem key={e.id} value={e.id}>
                              {e.title}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                    {/* <TextField
                                            id="outlined-multiline-flexible"
                                            label="Ποινή"
                                            multiline
                                            rows="4"
                                            onChange={(e) => handleChangeText(e)}
                                            value={textValue}
                                        /> */}
                  </CardContent>
                </Grid>
                <Grid item xs={12}>
                  <CardContent>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={checked}
                          onChange={handleChangeCheck}
                          name="jason"
                        />
                      }
                      label="Ανάκληση Άδειας"
                    />
                  </CardContent>
                </Grid>
                <br />
                <Grid item xs={12}>
                  <Input
                    id="file_field"
                    name="file_field"
                    type="file"
                    onChange={(e) => setSelectedFile(e.target.files[0])}
                  />
                  <br />
                  <br />

                  {props.file && props.file.length > 0 && (
                    <div>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checkedFile}
                            onChange={handleFileChecked}
                          />
                        }
                        label={
                          <Typography style={{ color: "black" }}>
                            Διαγραφή <br />
                            {decodeURI(props.file.split("/").pop())}
                          </Typography>
                        }
                      />

                      {/* <Link href={props.file}>{decodeURI(props.file.split('/').pop())}</Link> */}
                    </div>
                  )}
                </Grid>
              </Grid>
            </Box>
          </Stack>
          <br />
          <br />

          <Typography>
            <Button variant="contained" color="success" onClick={SaveCard}>
              Αποθηκευση
            </Button>
          </Typography>
        </Box>
      </Modal>
    </div>
  );
}

function MetabibaseisModal(props) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [value, setValue] = React.useState(
    props.date ? new Date(props.date) : null
  );
  const [textValueFrom, setTextValueFrom] = React.useState(
    props.fromPerson ? props.fromPerson : ""
  );
  const [textValueTo, setTextValueTo] = React.useState(
    props.toPerson ? props.toPerson : ""
  );
  const [textValue, setTextValue] = React.useState(
    props.comments ? props.comments : ""
  );

  const [fromAfm, setfromAfm] = React.useState(props.fromAfm ? props.fromAfm : "");
  const [fromAddress, setfromAddress] = React.useState(props.fromAddress ? props.fromAddress : "");
  const [checkedFile, setCheckedFile] = React.useState(false);
  const [selectedFile, setSelectedFile] = React.useState(null);
  const [options, setOptions] = React.useState([]);
  const [valueOption, setValueOption] = React.useState(options[0]);
  const [valueFromPerson, setValueFromPerson] = React.useState("");
  const [valueToPerson, setValueToPerson] = React.useState("");
  const [afm, setAfm] = React.useState("");
  const [address, setAddress] = React.useState("");
  const [business, setBusiness] = React.useState("");

  const [previousTextValueTo, setPreviousTextValueTo] = React.useState("");

  const handleFromChange = (event) => {
    setTextValueFrom(event.target.value);
  };
  const handleFileChecked = (event) => {
    setCheckedFile(event.target.checked);
  };

  const handleToChange = (event) => {
    setTextValueTo(event.target.value);
  };
  const handleChangeText = (event) => {
    setTextValue(event.target.value);
  };
  const SaveCard = async () => {
    let data = new FormData();
    if (selectedFile) {
      data.append("file", selectedFile);
    }

    if (value == null || value === "") {
      alert("Παρακαλώ συμπληρώστε την Ημερομηνία");
      return;
    }

    data.append(
      "date",
      value
        .toLocaleDateString("el", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .split("/")
        .reverse()
        .join("-")
    );
    data.append("from_person", textValueFrom);


    if (textValueTo == null || textValueTo === "") {
      alert("Παρακαλώ επιλέξτε τον αποδέκτη");
      return;
    }
    data.append("afm", afm);
    data.append("address", address);
    data.append("to_person", textValueTo);

    data.append("comments", textValue);
    data.append("business", parseInt(props.personID));
    data.append("created_by", props.created_by);

    // data.append("business_transfer", parseInt(valueToPerson.id));
    try {
      if (props.action === "Create") {
        console.log(data);



        await session
          .post(`api/business-transfer/create/`, data, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((resp) => {
            EventSpy(1, `Δημιουργία Μεταβίβασης ${JSON.stringify(resp.data)}`);
          });

        let toPersonForm = new FormData();
        toPersonForm = data;
        // console.log(props);
        // let toPersonForm = new FormData();
        if (selectedFile) {
          toPersonForm.append("file", selectedFile);
        }
        toPersonForm.append(
          "date",
          value
            .toLocaleDateString("el", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            })
            .split("/")
            .reverse()
            .join("-")
        );
        toPersonForm.append("from_person", textValueFrom);
        toPersonForm.append("to_person", textValueTo);
        toPersonForm.append("comments", textValue);
        toPersonForm.append("business", parseInt(valueToPerson.id));
        toPersonForm.append("created_by", props.created_by);
        // toPersonForm.append("business_transfer", parseInt(props.personID));

        await session
          .post(`api/business-transfer/create/`, toPersonForm, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((resp) => {
            EventSpy(1, `Δημιουργία Μεταβίβασης ${JSON.stringify(resp.data)}`);
          });


      }
      else if (props.action === "Update") {
        if (checkedFile) {
          data.delete("file");
          data.append("file", "");
        }
        const paramsObj = { "from_person": data.get("from_person"), "to_person": (previousTextValueTo !== "" ? previousTextValueTo : data.get("to_person")) };
        const searchParams = new URLSearchParams(paramsObj);

        const responseBusinessTransferData = await session.get(`api/business-tranfer/list/?${searchParams.toString()}`);
        const transferData = responseBusinessTransferData.data;
        for (const tradata of transferData) {
          if (previousTextValueTo !== "" && data.get("from_person") !== tradata.business_details.userId) {
            let businessParamsObj = { "business_name": data.get("to_person") };
            let businessSearchParams = new URLSearchParams(businessParamsObj)
            session
              .put(`api/business-transfer/${tradata.id}/update/`, data, {
                headers: { "Content-Type": "multipart/form-data" },
              });
            await session
              .get(`api/business/?${businessSearchParams}`)
              .then((resp) => {
                let businessValue = resp.data.results;
                if (businessValue && businessValue.length > 0) {
                  setBusiness(businessValue[0].id);
                }
                data.set("business", businessValue[0].id);
              }
              )
          }
          else {
            data.set("business", tradata.business);
            // await session
            //   .put(`api/business-transfer/${tradata.id}/update/`, data, {
            //     headers: { "Content-Type": "multipart/form-data" },
            //   });
          }

          // session
          //   .put(`api/business-transfer/${tradata.id}/update/`, data, {
          //     headers: { "Content-Type": "multipart/form-data" },
          //   });

          await session
            .put(`api/business-transfer/${tradata.id}/update/`, data, {
              headers: { "Content-Type": "multipart/form-data" },
            })
            .then((responseBusinessTransferData) => {
              console.log("this is responseBusinessTransferData update:", responseBusinessTransferData.data);
              EventSpy(
                2,
                `Ανανέωση Μεταβίβασης ${JSON.stringify(responseBusinessTransferData.data)}`
              );
            });
        }
      };


      // if (previousTextValueTo !== "") {
      //   let businessValue = data.get("business");
      //   // let businessTransferValue = data.get("business_transfer");

      //   // console.log("bv:", businessValue);
      //   // console.log("btv:", businessTransferValue);

      //   // data.set("business", businessTransferValue);
      //   // data.set("business_transfer", businessValue);


      // }
      // else {
      //   data.set("business", tradata.business);
      // }


      // console.log("tradata_tra:", tradata.business_transfer);
      // console.log("tradata_biz:", tradata.business);

      // if (tradata.business_transfer) {
      //   console.log("mpike");

      //   console.log("before", data.get("business"));
      //   data.set("business", parseInt(tradata.business));
      //   console.log("after", data.get("business"));

      //   console.log("before", data.get("business_transfer"));
      //   data.set("business_transfer", parseInt(tradata.business_transfer));
      //   console.log("after", data.get("business_transfer"));
      // }
      // console.log("Tradata.id:", tradata.id);
      // session.put(`api/business-transfer/${props.id}/update/`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
      //     .then(() => setOpen(false), props.handleChange())
      // setCheckedFile(false)
    }
    catch (error) {
      console.error("Error updating transfer:", error);
    }
    finally {
      setOpen(false);
      props.handleChange();
      setCheckedFile(false);
      props.handleSpinner("metabibasiSpinner");
    }
  };

  const onInputChange = (e) => {
    session
      .get(`api/business/?business_name=${e.target.value}`)
      .then((resp) => {
        const results = resp.data.results;
        if (results && results.length > 0) {
          setOptions(results);
        }
      });
  };

  React.useEffect(() => {
    const defValueParamsObj = { "business_name": textValueTo };
    const defValueSearchParams = new URLSearchParams(defValueParamsObj);
    if (props.action === "Update") {
      session
        .get(`api/business/?${defValueSearchParams}`)
        .then((resp) => {
          const defValue = resp.data.results;
          if (defValue && defValue.length > 0) {
            setAfm(defValue[0].afmE);
            setAddress(defValue[0].dieuthinsi);
          }
        })
    }

  }, [props.action, textValueTo]);

  // const changeBusiness = async (data) => {
  //   let businessParamsObj = { "business_name": data.get("to_person") };
  //   let businessSearchParams = new URLSearchParams(businessParamsObj)
  //   await session
  //     .get(`api/business/?${businessSearchParams}`)
  //     .then((resp) => {
  //       let businessValue = resp.data.results;
  //       if (businessValue && businessValue.length > 0) {
  //         console.log(businessValue[0].id);
  //         setBusiness(businessValue[0].id);
  //         console.log(business);
  //       }
  //       console.log("before", data.get("business"));
  //       data.set("business", String(businessValue[0].id));
  //       console.log("after", data.get("business"));
  //     }
  //     )
  // }

  const like = (e, v) => {
    setPreviousTextValueTo(textValueTo !== null ? textValueTo : v.id);
    // otan pataei clear o xristis -> v === null kai crasharei to site
    setValueFromPerson(v !== null ? v.id : "");
    setTextValueTo(v !== null ? v.nameE : "");
    setAfm(v !== null ? v.afmE : "");
    setAddress(v !== null ? v.dieuthinsi : "");
    setValueToPerson(v !== null ? v : "");
  };

  return (
    <div>
      <Button onClick={handleOpen} variant="outlined">
        {" "}
        {props.buttonTitle ? props.buttonTitle : "Δημιουργια"}
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {props.title ? props.title : "Δημιουργία"} Μεταβίβασης
          </Typography>
          <hr />
          <Stack spacing={5}>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <CardContent>
                    <LocalizationProvider
                      dateAdapter={AdapterDateFns}
                      adapterLocale={grLocale}
                    >
                      <Stack spacing={4}>
                        <DesktopDatePicker
                          label="Ημερομηνία"
                          inputFormat="dd/MM/yyyy"
                          value={value}
                          onChange={(newValue) => setValue(newValue)}
                          renderInput={(params) => <TextField {...params} />}
                        />
                      </Stack>
                    </LocalizationProvider>
                  </CardContent>
                </Grid>
                <Grid item xs={12}>
                  <CardContent>
                    <TextField
                      label="Σχόλια"
                      id="outlined-multiline-flexible"
                      multiline
                      maxRows={4}
                      value={textValue}
                      onChange={handleChangeText}
                    />
                  </CardContent>
                </Grid>
                <Grid item xs={12}>
                  <CardContent>
                    <Box
                      component="form"
                      sx={cardBox}
                    >
                      <Typography
                        id="outline-multiline-flexible"
                        component="legend"
                        sx={cardBoxTypo}
                      >
                        &nbsp;Από&nbsp;
                      </Typography>
                      <TextField
                        label="Όνομα"
                        id="standard-multiline-flexible"
                        disabled
                        multiline
                        maxRows={4}
                        minRows={4}
                        variant="standard"
                        value={textValueFrom}
                        onChange={handleFromChange}
                      />
                      <TextField
                        label="ΑΦΜ"
                        id="standard-multiline-flexible"
                        multiline
                        maxRows={4}
                        minRows={4}
                        variant="standard"
                        value={fromAfm} //afmE
                        disabled
                      />
                      <TextField
                        label="Διεύθυνση"
                        id="standard-multiline-flexible"
                        multiline={false}
                        maxRows={4}
                        minRows={4}
                        variant="standard"
                        value={fromAddress} //dieuthinsi
                        disabled
                      />
                    </Box>
                  </CardContent>
                </Grid>
                <Grid item xs={12}>
                  <CardContent>
                    <Box
                      component="form"
                      sx={cardBox}
                    >
                      <Typography
                        id="outlined-multiline-flexible-label"
                        sx={cardBoxTypo}
                      >
                        &nbsp;Προς&nbsp;
                      </Typography>
                      <TextField
                        label="Όνομα"
                        id="standard-multiline-flexible"
                        multiline
                        maxRows={4}
                        minRows={4}
                        variant="standard"
                        value={textValueTo}
                        disabled
                      />
                      <TextField
                        label="ΑΦΜ"
                        id="standard-multiline-flexible"
                        multiline
                        maxRows={4}
                        minRows={4}
                        variant="standard"
                        value={afm} //afmE
                        disabled
                      />
                      <TextField
                        label="Διεύθυνση"
                        id="standard-multiline-flexible"
                        multiline={false}
                        maxRows={4}
                        minRows={4}
                        variant="standard"
                        value={address} // dieuthinsi
                        disabled
                      />
                    </Box>
                  </CardContent>
                  <CardContent>
                    <Autocomplete
                      value={valueOption}
                      // defaultValue={defaultValue}
                      // `${ valueOption.nameE } - ${ valueOption.afmE } - ${ valueOption.dieuthinsi }`
                      onChange={like}
                      id="combo-box-demo"
                      loading
                      loadingText="Φόρτωση"
                      options={options}
                      noOptionsText="Δεν βρεθηκαν Αποτελέσματα"
                      onInputChange={onInputChange}
                      getOptionLabel={(option) => `${option.nameE} - ${option.afmE} - ${option.dieuthinsi}`}
                      style={{ width: 300 }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Αναζήτηση Επιχείρησης"
                          variant="outlined"
                        />
                      )}
                    />
                  </CardContent>
                </Grid>
                <Grid item xs={12}>
                  <Input
                    //  multiple
                    id="file_field"
                    name="file_field"
                    type="file"
                    onChange={(e) => setSelectedFile(e.target.files[0])}
                  />
                  <br />
                  <br />
                </Grid>

                {props.file && props.file.length > 0 && (
                  <div>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={checkedFile}
                          onChange={handleFileChecked}
                        />
                      }
                      label={
                        <Typography style={{ color: "black" }}>
                          Διαγραφή <br />
                          {decodeURI(props.file.split("/").pop())}
                        </Typography>
                      }
                    />

                    {/* <Link href={props.file}>{decodeURI(props.file.split('/').pop())}</Link> */}
                  </div>
                )}
              </Grid>
            </Box>
          </Stack>
          <br />
          <br />
          <Typography>
            <Button variant="contained" color="success" onClick={SaveCard}>
              Αποθηκευση
            </Button>
          </Typography>
        </Box>
      </Modal>
    </div>
  );
}

const customStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function PoinesParabaseisModal(props) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [poines, setPoines] = React.useState(props.poines);
  const [checkedViolation, setCheckedViolation] = React.useState(false);
  const [openViolation, setOpenViolation] = React.useState(false);
  const [business, setBusiness] = React.useState(props.business);

  React.useEffect(() => {
    session.get(`api/Epixeiriseis/${business}/`, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then((resp) => {
      const isTransferable = resp.data.is_not_transferable;
      setCheckedViolation(isTransferable);
      setOpenViolation(isTransferable);
    }).catch((err) => {
      console.error("Failed to fetch violation status:", err);
    });
  }, [business]);

  const handleCheckboxChange = () => {
    const newChecked = !checkedViolation;
    setCheckedViolation(newChecked);
    setOpenViolation(newChecked);
    if (props.onTransferabilityChange) {
      props.onTransferabilityChange(newChecked);
    }
    console.log(props)
    session.patch(`api/Epixeiriseis/${business}/`, { "is_not_transferable": newChecked },).then((resp) => {
      console.log(resp);
    });

    return newChecked;
  };

  return (
    <div style={{ display: "flex", justifyContent: "right" }}>
      <FormControlLabel
        control={
          <Checkbox
            checked={checkedViolation}
            onChange={handleCheckboxChange}
          />}
        label="Απαγόρευση Μεταβίβασης"
        labelPlacement="start"
      />


      <Button onClick={handleOpen} variant="contained">
        {" "}
        Συνολικες Ποινες
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={customStyle}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Συνολικές Παραβάσεις ανά κατηγορία παράβασης -{" "}
            {new Date().getFullYear()}
          </Typography>
          <hr />
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Έτος</TableCell>
                  {/* <TableCell align="right">Ώρα Δημιουργίας</TableCell> */}
                  <TableCell align="center">Κατηγορία Παράβασης</TableCell>
                  <TableCell align="right">Σύνολο</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props.poines &&
                  props.poines.length > 0 &&
                  props.poines.map((row, idx) => (
                    <TableRow key={idx}>
                      <TableCell>{row.date__year}</TableCell>
                      <TableCell align="center">{row.eidos__title}</TableCell>
                      <TableCell
                        align="right"
                        style={{ color: row.cnt_eidos >= 3 ? "red" : "" }}
                      >
                        {" "}
                        {row.cnt_eidos}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Modal>
    </div>
  );
}

export { ParabaseisModal, MetabibaseisModal, PoinesParabaseisModal };

